import { Hourglass, CalendarDays, Check, ArrowRight } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

const OPTIONS = [
  {
    icon: Hourglass,
    title: "One-Time Delivery",
    kicker: "ONE-TIME · SPECIAL REQUEST · SINGLE SHIPMENT",
    desc: "We offer flexible solutions tailored to your unique needs, whether you require a one-time order, a special request, or a single shipment—allowing you to focus on other important aspects of your business.",
    featured: false,
  },
  {
    icon: CalendarDays,
    title: "Recurring Delivery",
    kicker: "WEEKLY · MONTHLY · CUSTOM SCHEDULES",
    desc: "Whether you need weekly, monthly, or customized deliveries, you can establish a recurring schedule to maintain a consistent supply of goods without having to place repeated orders.",
    featured: true,
  },
];

const SHARED = [
  "Vetted, professional Drivers",
  "High On-Time Delivery Rate",
  "API Integration",
  "On-time, every time",
  "Door-To-Door Service",
  "Customer Service available 24/7/365",
];

export const Pricing = () => (
  <section id="pricing" data-testid="pricing-section" className="bg-white py-24 lg:py-32 scroll-mt-20">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl mx-auto text-center">
        <Overline>Pricing</Overline>
        <h2 className="mt-5 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 leading-tight">
          Simple, Transparent Pricing
        </h2>
        <p className="mt-5 text-base leading-relaxed text-slate-600">
          No hidden cost, extra fees, or clauses written in fine print. You pay only for the services you need.
        </p>
      </Reveal>

      <Reveal delay={0.1} className="mt-16 max-w-2xl">
        <h3 className="font-display text-xl sm:text-2xl font-bold tracking-tight text-slate-900">
          We Offer Two Types Of Deliveries
        </h3>
        <p className="mt-3 text-base leading-relaxed text-slate-600">
          HLM offers both features for all delivery types, choose the best for your business.
        </p>
      </Reveal>

      <div className="mt-8 grid md:grid-cols-2 gap-6">
        {OPTIONS.map((o, i) => (
          <Reveal key={o.title} delay={i * 0.1}>
            <div data-testid={`pricing-option-card-${i}`}
                 className={`relative h-full rounded-[1.5rem] p-8 border transition-all duration-300 hover:shadow-xl ${
                   o.featured
                     ? "bg-[#0B1D4F] border-blue-900 text-white shadow-lg shadow-blue-900/20"
                     : "bg-[#F8FAFC] border-slate-200/80 hover:border-blue-500/40"
                 }`}>
              <span className={`h-14 w-14 rounded-2xl flex items-center justify-center ${
                o.featured ? "bg-[#1E6FFF]" : "bg-blue-50 border border-blue-100"
              }`}>
                <o.icon className={`h-7 w-7 ${o.featured ? "text-white" : "text-[#0047FF]"}`} strokeWidth={1.9} />
              </span>
              <p className={`mt-6 font-mono text-[10px] font-semibold tracking-[0.18em] uppercase ${
                o.featured ? "text-blue-300" : "text-[#0047FF]"
              }`}>
                {o.kicker}
              </p>
              <h4 className={`mt-2.5 font-display text-xl sm:text-2xl font-bold tracking-tight ${o.featured ? "text-white" : "text-slate-900"}`}>
                {o.title}
              </h4>
              <p className={`mt-3 text-sm sm:text-base leading-relaxed ${o.featured ? "text-slate-300" : "text-slate-600"}`}>{o.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div className="mt-8 rounded-[1.5rem] border border-slate-200/80 bg-[#F8FAFC] p-8">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 font-mono">Every delivery includes</p>
          <div className="mt-5 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-4">
            {SHARED.map((f) => (
              <span key={f} data-testid={`pricing-feature-${f.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    className="flex items-center gap-2.5 text-sm font-semibold text-slate-800">
                <span className="h-5 w-5 rounded-full bg-red-500 shadow-sm shadow-red-500/30 flex items-center justify-center shrink-0">
                  <Check className="h-3 w-3 text-white" strokeWidth={3.5} />
                </span>
                {f}
              </span>
            ))}
          </div>
          <a href="#quote" data-testid="pricing-quote-cta"
             className="group mt-8 inline-flex items-center gap-2.5 rounded-full bg-[#0047FF] px-6 py-3.5 text-sm font-bold text-white shadow-lg shadow-blue-600/25 hover:bg-[#0037CC] transition-colors duration-200">
            Get A Quote
            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
